import SagarMeinYog from "@/assets/sagar_mein_yog.svg";

const LoadingOverlay = ({
  isLoading,
  message = "Loading...",
  spinnerColor = "var(--primary-font)",
  overlayColor = "rgba(255, 255, 255, 0.6)",
  logoSize = 80,
}) => {
  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center animate-fadeIn"
      style={{ backgroundColor: overlayColor }}
      aria-busy="true"
      role="status"
    >
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div
          className="rounded-full animate-spin"
          style={{
            width: 80,
            height: 80,
            borderWidth: 6,
            borderStyle: "solid",
            borderColor: `${spinnerColor} transparent ${spinnerColor} transparent`,
            borderRadius: "50%",
          }}
        />

        {/* Logo */}
        <img
          src={SagarMeinYog}
          alt="Sagar Mein Yog Logo"
          width={logoSize}
          height={logoSize}
          className="object-contain"
        />

        {/* Message */}
        <span
          className="text-2xl font-medium text-center"
          style={{ color: spinnerColor }}
        >
          {message}
        </span>
      </div>

      {/* Tailwind fadeIn animation */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default LoadingOverlay;
